export const environment = {
  production: true,
  buildId: '2767881086418881',
  configFile: 'config.json',
};
